import { BrowserClient } from '@sentry/browser';
import { BreadcrumbHint, Breadcrumb, EventHint, Event } from '@sentry/types';
import { last as _last } from 'lodash';
import { getModuleParams } from './bmUtils';
import { InboxError } from '../Errors/InboxError';

let sentryInboxClient: BrowserClient;
let sentryInboxSettingsClient: BrowserClient;

//extract the latest GAed version.
const extractLatestGAVersion = (staticsBaseUrl: string) => {
  const urlParts = staticsBaseUrl.split('/').filter(Boolean);

  return urlParts.length > 1 ? _last(urlParts) : null;
};

const blacklistUrls = ['unpkg/@wix/ck-editor-angular'];

const beforeBreadcrumb = (
  breadcrumb: Breadcrumb,
  hint?: BreadcrumbHint,
): Breadcrumb => {
  if (hint && breadcrumb.category === 'ui.click') {
    const target = hint.event.target as HTMLElement;
    const message = target.getAttribute('data-hook');
    if (message) {
      breadcrumb.message = message;
    }
  }

  if (hint && breadcrumb.category === 'xhr') {
    const response = (hint.xhr as XMLHttpRequest).response;

    if (response) {
      const dataWithResponse = breadcrumb.data.concat(`response ${response}`);
      breadcrumb.data = dataWithResponse;
    }
  }

  return breadcrumb;
};

const enrichWithExtraDataFromException = (event: Event, hint?: EventHint) => {
  if (hint && hint.originalException) {
    const data = (hint.originalException as InboxError).data;
    if (data) {
      if (data.level) {
        event.level = data.level;
      }

      if (data.extraData) {
        event.extra = { ...event.extra, ...data.extraData };
      }
    }
  }
};

const beforeSend = (event: Event, hint?: EventHint): Event => {
  enrichWithExtraDataFromException(event, hint);
  return event;
};

export const getSentryInboxClient = () => {
  if (sentryInboxClient) {
    return sentryInboxClient;
  }

  const latestGAVersion = extractLatestGAVersion(
    getModuleParams().config.topology.engageWebStaticsUrl,
  );

  sentryInboxClient = new BrowserClient({
    dsn: 'https://a9bd970380d84cd5a459ca48c4171497@sentry.wixpress.com/29',
    enabled: !!latestGAVersion,
    release: `engage-web@${latestGAVersion}`,
    blacklistUrls,
    beforeSend,
    beforeBreadcrumb,
  });

  if (!latestGAVersion) {
    console.warn('inbox Sentry was not initialized!');
  }

  return sentryInboxClient;
};

export const getSentryInboxSettingsClient = () => {
  if (sentryInboxSettingsClient) {
    return sentryInboxSettingsClient;
  }

  const latestGAVersion = extractLatestGAVersion(
    getModuleParams().config.topology.inboxSettingsStaticsUrl,
  );

  sentryInboxSettingsClient = new BrowserClient({
    dsn: 'https://a7eaee13b06e48678e08fb3cb3c0ee68@sentry.wixpress.com/30',
    enabled: !!latestGAVersion,
    release: `inbox-settings@${latestGAVersion}`,
    blacklistUrls,
    beforeSend,
    beforeBreadcrumb,
  });

  if (!latestGAVersion) {
    console.warn('inbox-settings Sentry was not initialized!');
  }

  return sentryInboxSettingsClient;
};
